(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.initBarCharts = {
    attach: function (context, settings) {
      once('cdss-blocks-bar-chart', '.cdss-blocks-bar-chart', context).forEach(initBarCharts);
    }
  }

  function initBarCharts(el) {
    const chartSeries = $(el).attr('data-series');
    const chartCategories = $(el).attr('data-chart-categories');
    const x_axis_label = $(el).attr('data-x_axis_label');
    const y_axis_label = $(el).attr('data-y_axis_label');
    const chart_series_name = $(el).attr('data-chart_series_name');

    // const pieChartType = $(el).attr('data-pie_chart_type');
    // let startAngle = $(el).attr('data-chart_start_angle');

    // startAngle = Number(startAngle);
    // console.log(typeof startAngle);
    

    if (chartSeries) {
      try {
        const data = JSON.parse(chartSeries);
        const categories = JSON.parse(chartCategories);
        drawBarChart(el, data, categories, x_axis_label, y_axis_label, chart_series_name);
      } catch (e) {
        console.error("Invalid JSON data:", e);
      }
    }
  }

  function drawBarChart(el, data, categories, x_axis_label, y_axis_label, chart_series_name) {
    Highcharts.setOptions({
      lang: {
          accessibility: {
              chartContainerLabel: "{title}Highcharts interactive enrollment chart"
      }}})
    Highcharts.chart(el, {
    chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    subtitle: {
        text:
            ''
    },
    legend:{ enabled:false },
    xAxis: {
        categories: categories,
        crosshair: true,
        accessibility: {
            description: 'Categories'
        },
        title: {
          text: x_axis_label,
          style: {
            fontSize: '16px' 
         }
      },
      labels: {
        style: {
            fontSize: '16px'
        }
      }
    },
    yAxis: {
        min: 0,
        title: {
            text: y_axis_label,
            style: {
              fontSize: '16px' 
           }
        },
        labels: {
          style: {
              fontSize: '16px'
          }
        }
    },
    tooltip: {
        valueSuffix: ' '
    },
    plotOptions: {
        column: {
            pointPadding: 0.2,
            borderWidth: 0
        }
    },
    series: data

    });
  }

})(jQuery, Drupal, drupalSettings);
